import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'StatisticWidget' })({
    container: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 8,
        borderRadius: 24,
        border: '1px solid #ECECEC',
        background: 'transparent',
        transition: 'all 0.3s',
        padding: 20,
        boxSizing: 'border-box',
        ['&:hover']: {
            background: '#FFF',
            boxShadow: '0px 8px 16px 0px rgba(176, 178, 186, 0.10), 0px 12px 32px 0px rgba(176, 178, 186, 0.25)'
        }
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        flex: 1
    },
    value: {
        flex: 1,
        color: '#232323',
        fontSize: 24,
        fontWeight: 700,
        lineHeight: '150%'
    },
    description: {
        color: '#232323',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '16px'
    },
    button: {
        padding: 8,
        borderRadius: 12,
        border: '1px solid #ECECEC',
        ['& svg']: {
            width: 16,
            height: 16
        }
    }
});
